import React from 'react';

function Placeholder({ label, phase = 'Phase 2' }) {
  return (
    <div className="border-2 border-dashed border-bg-border rounded-lg bg-bg-ice p-6 text-center my-4">
      <span className="inline-block bg-amber-tint text-amber-tinttext text-xs font-sans font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wide">
        Coming in {phase}
      </span>
      <p className="font-sans text-slate text-sm">{label}</p>
    </div>
  );
}

export default Placeholder;
